import type { BadgeVariant } from "@replicate/ui";
import { Badge } from "@replicate/ui";
import type { PredictionStatus } from "../types";
import { getHumanStatus } from "../util";

const statusToVariantMap: Record<PredictionStatus, BadgeVariant> = {
  succeeded: "success",
  failed: "danger",
  starting: "accent",
  canceled: "default",
  canceling: "default",
  processing: "accent",
  aborted: "danger",
};

export function StatusBadge({ status }: { status: PredictionStatus }) {
  return (
    <Badge variant={statusToVariantMap[status]} size="sm">
      {getHumanStatus(status)}
    </Badge>
  );
}
